import { toSafeRichHtml } from "@/lib/safe-html";

type Props = {
  html: string;
  className?: string;
  as?: "div" | "p" | "span";
};

const HEADING_STYLES = [
  "[&_h1]:mt-6 [&_h1]:mb-3 [&_h1]:font-[family-name:var(--font-serif)] [&_h1]:text-3xl [&_h1]:leading-tight [&_h1]:text-stone-950",
  "[&_h2]:mt-5 [&_h2]:mb-2 [&_h2]:font-[family-name:var(--font-serif)] [&_h2]:text-2xl [&_h2]:leading-tight [&_h2]:text-stone-950",
  "[&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:font-[family-name:var(--font-serif)] [&_h3]:text-xl [&_h3]:leading-snug [&_h3]:text-stone-950",
  "[&_h4]:mt-4 [&_h4]:mb-1.5 [&_h4]:text-lg [&_h4]:font-semibold [&_h4]:text-stone-900",
  "[&_h5]:mt-3 [&_h5]:mb-1 [&_h5]:text-base [&_h5]:font-semibold [&_h5]:text-stone-900",
  "[&_h6]:mt-3 [&_h6]:mb-1 [&_h6]:text-sm [&_h6]:font-semibold [&_h6]:uppercase [&_h6]:tracking-wide [&_h6]:text-stone-800",
  "[&_:is(h1,h2,h3,h4,h5,h6):first-child]:mt-0",
  "[&_p]:mb-3 [&_p:last-child]:mb-0",
].join(" ");

/** Renders admin-authored copy with a small, sanitized HTML subset. */
export function RichText({ html, className, as: Tag = "div" }: Props) {
  const safe = toSafeRichHtml(html);
  if (!safe) return null;
  return (
    <Tag
      className={[HEADING_STYLES, className].filter(Boolean).join(" ")}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
